import router from './routers'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css'// progress bar style
import { getToken, removeToken } from '@/utils/auth' // getToken from cookie
import Cookies from 'js-cookie'

// NProgress.configure({ showSpinner: false })
const whiteList = ['/login', '/register-type', '/register', '/register-uk',
  '/oa-sign', '/open-sign', '/unifysign', '/unifysign/sign', '/unifysign/auto-redirect',
  '/unifysign/launch', '/autoLogin/', '/file-check', '/open/seal/handwrite', '/open/seal/handwriteSuccess'
,'/open/personAuth/authSuccess' ,'/open/personAuth/authFailed', '/documentCenter','/electronSeal/serveOrder'
 , '/open/personAuth/authSuccessOpen' ,'/open/personAuth/authFailedOpen','/open/formsign/signLink','/open/formsign/verifyLink','/app/unifysign/sign','/electronSeal/serveOrderList']  // no redirect whitelist
router.beforeEach((to, from, next) => {
  // NProgress.start()
  // if (to.query.autoTokenSid) {
  //   if (getToken()) {
  //     removeToken();
  //   }
  //   if (to.path !== "/loading") {
  //     next(`/loading?autoTokenSid=${to.query.autoTokenSid}`) // 否则全部重定向到登录页
  //   }else{
  //     next();
  //   }
  // }
  if (to.query.inviteCode) {
    Cookies.set('inviteCode', to.query.inviteCode)
  }
  if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
    next()
  } else {
    if (getToken()) {
      // 已登录且要跳转的页面是登录页
      if (to.path === '/login') {
        next({ path: '/' })
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }

  // NProgress.done()
})

router.afterEach(() => {
  // NProgress.done() // finish progress bar
})
